import { createSlice } from "@reduxjs/toolkit";
import { deleteAdjustment, fetchAdjustmentRecord } from "./AdjustmentRecordThunk";

const initialState = {
  list: [],
  loading: false,
  filters: {
    filterType: "All",
    recordType: "without item",
    fromDate: null,
    toDate: null,
  },
};

const adjustmentRecordSlice = createSlice({
  name: "adjustmentRecord",
  initialState,
  reducers: {
    setFilters: (state, action) => {
      state.filters = { ...state.filters, ...action.payload };
    },
    resetList: (state) => {
      state.list = [];
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAdjustmentRecord.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchAdjustmentRecord.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload;
      })
      .addCase(fetchAdjustmentRecord.rejected, (state) => {
        state.loading = false;
      })
      .addCase(deleteAdjustment.fulfilled, (state, action) => {
      state.list = state.list.filter(
        (e) => e.id !== action.payload.adjust_id
      );
    });
  },
});

export const { setFilters, resetList } = adjustmentRecordSlice.actions;
export default adjustmentRecordSlice.reducer;
